import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('selectFieldField');

    return {
        FIELD: t('field'),
        FIELD_IS_REQUIRED: t('fieldIsRequired')
    };
};

export default useTranslation;
